<img [attr.src]="value | secureUrl" alt="image" aria-label="draw">
